import styled from 'styled-components';
import { FilterContainerWrapper } from '@bit/knotchinc.web-react-components.filter-container';
import {
  ChecklistTick,
  ChecklistItemName,
  ChecklistItemContainer,
} from 'components/Global/Filters/EntityFilter/styled.js';
import { EntityIcon } from 'components/Global/EntityItem/styled';
import searchIconWhite from 'images/icons/searchIconWhite.svg';
import xCancelIcon from 'images/icons/x_cancelWhite.svg';
import { absFull } from 'helpers/styles.js';

const iconMap = {
  searchWhite: searchIconWhite,
  xCancel: xCancelIcon,
};

/* TOGGLES */
export const CompareToggleTitle = styled.div`
  font-size: 14px;
  line-height: 28px;
  text-transform: capitalize;
  color: #000000;
  float: left;
`;

export const CompareToggleTopSection = styled.div`
  display: block;
  height: 28px;
`;

export const CompareToggleWrapper = styled.div`
  width: 300px;
  padding: 20px 30px;
  margin-bottom: 5px;
  max-height: ${({ comparing }) => (comparing ? '525px' : '68px')};
  border-radius: 10px;
  background-color: ${({ theme, comparing }) => (comparing ? theme.colors.palette[2] : '#ffffff')};
  overflow: hidden;
  transition: max-height 0.6s ease, background-color 0.2s ease;
  height: auto;

  ${CompareToggleTitle} {
    color: ${({ comparing }) => comparing && '#ffffff'};
  }
`;

export const StyledComparePrompt = styled.div`
  color: ${({ theme }) => theme.colors.palette[6]};
  font-size: 10px;
  line-height: 14px;
  margin-bottom: 10px;
  ${({ theme, showBorder }) =>
    showBorder &&
    `
      border-bottom: 1px solid ${theme.colors.palette[3]};
      letter-spacing: 1px;
      text-transform: uppercase;
      padding-bottom: 7px;`};
`;

export const SelectedCompareEntitiesContainer = styled.div`
  margin-bottom: 10px;
`;

export const CompareToggleListSection = styled.div`
  display: block;
  margin-top: 15px;
  background-color: ${({ theme }) => theme.colors.palette[2]};

  input {
    background: url('${iconMap.searchWhite}') 12px 12px no-repeat;
    background-color: ${({ theme }) => theme.colors.palette[3]};
    color: #ffffff;

    &::placeholder {
      color: ${({ theme }) => theme.colors.palette[5]};
    }
  }


  ${FilterContainerWrapper} {
    background: ${({ theme }) => theme.colors.palette[2]};
    margin-bottom: 0px;
    border-bottom: none;
    padding: 0;

    > div {
      padding-top: 16px;
    }

    ${EntityIcon} {
      margin: 0 11px 0 4px;
    }
  }
`;

export const StyledCompareEntityItemContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.palette[7]};
  border-radius: 30px;
  padding: 5px 6px;
  display: inline-block;
  margin: 3px;
  position: relative;
`;

export const StyledCompareEntityItem = styled.div`
  max-width: 90%;
  padding: 0 30px 0 8px;
  display: inline-block;
  color: white;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  vertical-align: middle;
`;

export const StyledCompareEntityIcon = styled.div`
  vertical-align: middle;
  background-image: ${({ logo_url }) => `url('${logo_url}')`};
  width: 17px;
  height: 17px;
  border-radius: 100%;
  background-color: white;
  display: inline-block;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const RemoveCompareEntity = styled.div`
  vertical-align: middle;
  background:  url('${iconMap.xCancel}');
  background-color: #397DEE;
  width: 14px;
  height: 14px;
  border-radius: 100%;
  display: inline-block;
  margin: 0 4px;
  cursor: pointer;
  background-position: center;
  background-repeat: no-repeat;
  ${absFull('7px', '5px', 'auto', 'auto')};
`;

/* Entity Filter List Items */
export const StyledCheckListItemContainer = styled(ChecklistItemContainer)``;

export const StyledCheckListTick = styled(ChecklistTick)`
  background: ${({ theme }) => theme.colors.palette[3]};
`;

export const StyledCheckListItemName = styled(ChecklistItemName)`
  color: #ffffff;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  &::after {
    ${({ isCurrentEntity, theme }) => isCurrentEntity && `
      content: 'You';
      background: ${theme.colors.palette[5]};
      border-radius: 3px;
      font-size: 10px;
      padding: 4px;
      vertical-align: middle;
      text-align: center;
      margin-left: 5px;
    `};
  }
`;
